import * as React from "react"

const SvgBook = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 20.121a2 2 0 0 1-.537-.075 2.3 2.3 0 0 1-.488-.2 8.8 8.8 0 0 0-2.15-.95 8.3 8.3 0 0 0-2.325-.325q-1.05 0-2.063.275a9 9 0 0 0-1.937.775q-.526.276-1.012-.025A.97.97 0 0 1 1 18.721V6.671q0-.274.137-.525a.86.86 0 0 1 .413-.375q1.15-.6 2.4-.9t2.55-.3a10.8 10.8 0 0 1 5.5 1.5v12.1q1.275-.8 2.675-1.2a10.24 10.24 0 0 1 4.587-.25q.863.15 1.738.45v-12q.375.126.738.263.362.138.712.337.274.126.413.375.137.25.137.525v12.05a.97.97 0 0 1-.488.875q-.487.3-1.012.025a9 9 0 0 0-1.938-.775 7.8 7.8 0 0 0-2.062-.275q-1.2 0-2.325.325a8.8 8.8 0 0 0-2.15.95q-.225.125-.488.2-.262.075-.537.075m2.825-5.3q-.25.226-.537.088a.475.475 0 0 1-.288-.463V6.271a.47.47 0 0 1 .15-.35l4-4q.25-.25.55-.125.3.126.3.475v8.575a.4.4 0 0 1-.05.213.8.8 0 0 1-.125.162zM10 17.196v-9.9a9.3 9.3 0 0 0-1.713-.537A8.6 8.6 0 0 0 6.5 6.57q-.926 0-1.8.175A8.7 8.7 0 0 0 3 7.27v9.925a9.8 9.8 0 0 1 3.5-.625 9.8 9.8 0 0 1 3.5.625Z" />
  </svg>
)
export default SvgBook
